import React, {useState} from 'react'
import "./style/style.css"
import {
    Affix,
    Alert,
    Button,
    Divider,
    Input,
    message,
    PageHeader,
    Row,
    Space,
    Spin,
    Table,
    Tag,
    Typography,
} from 'antd';
import softwareApi from "services/software";
import {FilePdfOutlined, SettingOutlined} from "@ant-design/icons";


const {Paragraph, Link} = Typography;
const {TextArea} = Input;

const REPORT_DEFAULT_PROMPT = "PROCEDURE: Chest xray. COMPARISON: last seen on 1/1/2020 and also record dated of March 1st, 2019. FINDINGS: patchy airspace opacities. IMPRESSION: The results of the chest xray of January 1 2020 are the most concerning ones. The patient was transmitted to another service of UH Medical Center under the responsability of Dr. Perez. We used the system MedClinical data transmitter and sent the data on 2/1/2020, under the ID 5874233. We received the confirmation of Dr Perez. He is reachable at 567-493-1234."


const columns = [
    {
        title: 'word',
        dataIndex: 'word',
        key: 'word',
    },
    {
        title: 'score',
        dataIndex: 'score',
        key: 'score',
    },
    {
        title: 'entity_group',
        dataIndex: 'entity_group',
        key: 'entity_group',
    },
    {
        title: 'start',
        dataIndex: 'start',
        key: 'start',
    },
    {
        title: 'end',
        dataIndex: 'end',
        key: 'end',
    },
];


const Content = ({children, extraContent}) => (
    <Row key={"rowContent"}>
        <div key="children" style={{flex: 1,}}>{children}</div>
        <div key="extraContent" className="image">{extraContent}</div>
    </Row>
);

const DeID = () => {


    const [reportSentIsLoading, setReportSentIsLoading] = useState(false);
    const [reportInput, setReportInput] = useState(REPORT_DEFAULT_PROMPT);
    const [annotations, setAnnotations] = useState(null);

    const getDeID = async (report) => {
        return await softwareApi.callDeID(report)
    }


    const reportOnChange = (e) => {
        setReportInput(e.target.value);
    };


    function resetAll() {
        setReportInput(REPORT_DEFAULT_PROMPT)
        setReportSentIsLoading(false)
        setAnnotations(null)
    }

    function displayError(msg) {
        message.error(msg);
        resetAll()
    }


    async function submitReport() {
        setReportSentIsLoading(true)

        // get annotations
        const ret = await getDeID(reportInput)

        if (typeof ret !== 'object') {
            displayError("Backend is offline");
            resetAll()
            return
        }

        if ("error" in ret) {
            displayError(ret["error"]);
            resetAll()
            return
        }

        // Table annotations
        let annotations = ret["data"]
        setAnnotations(annotations)
        setReportSentIsLoading(false)
    }

    // HTML
    let modifiedText = reportInput;
    if (annotations) {
        const colors = {
            "DATE": "fuchsia",
            "VENDOR": "fuchsia",
            "HCW": "orange",
            "PHONE": "orange",
            "HOSPITAL": "violet",
            "ID": "violet"
        }
        let offset = 0; // initialize an offset variable
        annotations.forEach(entity => {
            const {start, end, entity_group} = entity;
            const entityWord = reportInput.substring(start, end)
            const entityColor = colors[entity_group]
            const replacement = `<span data-entity="${entity_group}" class="bg-${entityColor}-100 text-${entityColor}-800 rounded px-1 py-0.5 dark:text-${entityColor}-100 dark:bg-${entityColor}-700">${entityWord}<span class="text-xs select-none bg-${entityColor}-500 text-${entityColor}-100 rounded font-semibold px-0.5 ml-1">${entity_group}</span></span>`;
            modifiedText = modifiedText.substring(0, start + offset) + replacement + modifiedText.substring(end + offset);
            offset += replacement.length - (end - start); // update the offset
        });
    }


    return (
        <>
            <div style={{width: 900}}>
                <Space direction={"vertical"} size={15}>
                    <PageHeader
                        title=""
                        className="site-page-header"
                        subTitle="Automated deidentification of radiology reports combining
                                transformer and “hide in plain sight” rule-based methods"
                        extra={[
                            <Button key="b3" icon={<FilePdfOutlined/>}
                                    href={"https://academic.oup.com/jamia/article/30/2/318/6843283"}>Paper</Button>,
                        ]}
                        avatar={{
                            src: 'data:image/jpeg;base64,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',
                        }}
                    >
                        <Content
                            extraContent={
                                <img
                                    src="/images/jamia_h11078762397.svg"
                                    alt="content"
                                    width="146px"
                                />
                            }
                        >
                            <>
                                <Paragraph>
                                    Authors develop an automated deidentification pipeline for radiology reports that
                                    detect
                                    protected health information (PHI) entities and replaces them with realistic
                                    surrogates “hiding in plain sight.”<br/>
                                    Pierre J Chambon, Christopher Wu, Jackson M Steinkamp, Jason Adleberg, Tessa S
                                    Cook, Curtis P Langlotz

                                </Paragraph>
                            </>
                        </Content>
                    </PageHeader>

                    Please paste your radiology report:
                    {reportInput.trim() &&
                        <Button type="primary" style={{float: "right"}} onClick={() => submitReport()}>
                            De-identify my report
                        </Button>
                    }
                    <TextArea
                        style={{width: 900}}
                        autoSize={{minRows: 4}}
                        onChange={reportOnChange}
                        defaultValue={REPORT_DEFAULT_PROMPT}
                    />

                    {reportSentIsLoading && <center><Spin/></center>}

                    {annotations &&
                        <div className="text-gray-800 leading-8 mt-2">
                            <div dangerouslySetInnerHTML={{__html: modifiedText}}></div>
                        </div>}

                    {annotations &&
                        <Table dataSource={annotations} columns={columns}/>
                    }
                </Space>
            </div>
        </>
    );
};


export default DeID
